import React from 'react';
import PropTypes from 'prop-types';

import ListInfoCardContainer from './ListInfoCardContainer';
import ListInfoCardRow from './ListInfoCardRow';
import ListInfoCardSingleRow from './ListInfoCardSingleRow';

const ListInfoCard = ({
  title,
  data,
  emptyContent,
  showEdit,
  handleEdit,
  showDelete,
  handleDelete,
}) => (
  <ListInfoCardContainer
    title={title}
    showEdit={showEdit}
    handleEdit={handleEdit}
    showDelete={showDelete}
    handleDelete={handleDelete}
  >
    {data.length === 0 && <ListInfoCardSingleRow>{emptyContent}</ListInfoCardSingleRow>}
    {data.map(({ label, value }, index) => (
      <ListInfoCardRow name={label} value={value} lastRow={index + 1 === data.length} key={index} />
    ))}
  </ListInfoCardContainer>
);

ListInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  emptyContent: PropTypes.node,
  showEdit: PropTypes.bool,
  handleEdit: PropTypes.func,
  showDelete: PropTypes.bool,
  handleDelete: PropTypes.func,
};

ListInfoCard.defaultProps = {
  data: [],
  emptyContent: undefined,
  showEdit: false,
  handleEdit: undefined,
  showDelete: false,
  handleDelete: undefined,
};

export default ListInfoCard;
